import GameUrlBuilderBase from '../../game/game_url_builder_base';

export default class GnwpGameUrlBuilder extends GameUrlBuilderBase {
    static CLASS = 'GnwpGameUrlBuilder';

    init(params) {
        super.init(params);

        if(!params.templateName) {
            this.throwArgumentExpected('10', 'init', 'templateName');
        }

        this._templateName = params.templateName;
        this._additionalParameters = params.additionalParameters;
    }

    buildRealGameUrl(gameOptions) {
        let gnwpParams = {
            gameType: gameOptions.gameType,
            externalGameCode: gameOptions.gameInfo && gameOptions.gameInfo.externalGameCode ? gameOptions.gameInfo.externalGameCode : null,
            currencyCode: this.serviceFactory.currencyService().getCurrency(),
            templateName: this._templateName,
            isReal: true,
            intervalReminder: gameOptions.realityCheckInterval.expectedValueByTheGame
        };

        if(gameOptions.token) {
            gnwpParams.token = gameOptions.token;
        }

        if(gameOptions.italy) {
            gnwpParams.gameLimit = gameOptions.italy.gameLimits;
        }

        return this._getGnwpResponse(gnwpParams);
    }

    buildAnonymousGameUrl(gameOptions) {
        return this._getGnwpResponse({
            gameType: gameOptions.gameType,
            externalGameCode: gameOptions.gameInfo && gameOptions.gameInfo.externalGameCode ? gameOptions.gameInfo.externalGameCode : null,
            currencyCode: this.serviceFactory.currencyService().getCurrency(),
            templateName: this._templateName,
            isReal: false,
            intervalReminder: 0
        });
    }

    buildHistoryGameUrl(gameOptions) {
        return this._getGnwpResponse({
            gameType: gameOptions.gameType,
            externalGameCode: gameOptions.gameInfo && gameOptions.gameInfo.externalGameCode ? gameOptions.gameInfo.externalGameCode : null,
            templateName: this._templateName,
            currencyCode: this.serviceFactory.currencyService().getCurrency(),
            isReal: true,
            isHistory: true,
            gameId: gameOptions.gameRoundId,
            target: 1
        });
    }

    _getGnwpResponse(params) {
        if(this._additionalParameters) {
            params = Object.assign(params, this._additionalParameters);
        }

        return this.serviceFactory.gnwpService().getGNWPResponse(params)
            .then(response => response.getGNWPUrl());
    }

}